/**
 * Identifiers for itinerary segmentation providers.
 * These values are used across segmentation, pricing, and offer pipelines.
 */
export enum SegmentationProviderId {

    /** Swiss CFF public transport provider. */
    "swiss_cff" = "swiss_cff",

    /** MOTIS rental provider for micromobility and rentals. */
    "rental_motis" = "rental_motis",

    /** BlaBlaCar carpool provider. */
    "blablacar" = "blablacar",

    /** BlaBlaDaily commuter carpool provider. */
    "blabladaily" = "blabladaily",

    /** Unknown provider fallback bucket. */
    "unknown" = "unknown",

    /** Completion strategy virtual provider. */
    "completion_strategy" = "completion_strategy",
}
